/* eslint-disable @typescript-eslint/no-unused-vars */
const setPlayerKey = (_key?: string): string | undefined => {
  return undefined;
};

export { setPlayerKey };
